import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SidePanelConfig } from '../../side-panel.constants';

@Component({
  selector: 'side-panel-overview-modal',
  templateUrl: './overview-modal.component.html',
  styleUrls: ['./overview-modal.component.scss'],
})
export class OverviewModalComponent {
  @Input() isMobileOverviewOpen = false;
  @Input() mobileConfig: SidePanelConfig;
  @Input() context: any;
  @Input() resourcesCustomContent: any = null;
  @Input() overviewCustomContent: any = null;
  @Output() isMobileOverviewOpenChange: EventEmitter<boolean> =
    new EventEmitter();

  handleCancel() {
    this.isMobileOverviewOpen = false;
    this.isMobileOverviewOpenChange.emit(this.isMobileOverviewOpen);
  }

  showCloseIcon(): boolean {
    return this.mobileConfig.showClose || false;
  }

  showBackIcon(): boolean {
    return this.mobileConfig.showBack || false;
  }
}
